import tw from './tw'
import jp from './jp'
import th from './th'
import en from './en'

export default {
  tw: tw,
  en: en,
  jp: jp,
  th: th
}



// WEBPACK FOOTER //
// ./src/locales/index.js